import md5 from 'blueimp-md5'

function getGravatarUrl(email, size) {
  return `https://www.gravatar.com/avatar/${md5(email)}?s=${size}&r=pg&d=identicon`
}

export default getGravatarUrl
